var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShares = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#abb3ba",
  d: "M5.971 1.607h-.005A5.82 5.82 0 0 0 .813 8.034a5.817 5.817 0 0 0 6.422 5.152 5.83 5.83 0 0 0 5.148-5.152H5.96zM7.007.783v6.22h6.215l-.005-.006a6.67 6.67 0 0 0-6.22-6.22z"
})));
export default SvgShares;